import React, { createRef, useEffect, useState } from "react";
import { Pressable, Text, View, Image, Keyboard } from "react-native";
import { store } from "../../store/store";
import { NavigateFrom, ScreenRoute } from "../../utils/constants/ScreenRouteConstant";
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { PrimaryCTA } from "../../utils/widgets/CommonCTA";

import disableScroll from "disable-scroll";
import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";
import AppTheme from "../../AppTheme";

import * as CommonUtils from '../../utils/services/CommonUtils';
import * as Redux from "../../utils/services/redux/commonRedux"
import * as Rxjs from "../../utils/services/subject-behaviour/CommonRxjsService";
import * as AppConstant from "../../utils/constants/AppConstants";
import * as AlertService from "../../utils/services/AlertLoaderService";
import * as MoengageUtils from "../../utils/services/webapp-services/MoengageUtils"
import * as PharmacyProfile from "../oms/omsUtils/pharmacyProfileWidget";
import * as OmsWidgets from "../../utils/services/oms/UpsertCartData";
import * as CommonWidget from "../../utils/widgets/Common-Widget"

const NotificationList = (props) => {

    return (
        <View>
            Notifications
        </View>
    )
}

export default NotificationList